<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <template v-slot:activator="{ on }">
        <v-btn small rounded outlined color="primary" v-on="on">
          <v-icon left small>mdi-credit-card-plus-outline</v-icon>
          {{ buttonLabel }}
        </v-btn>
      </template>

      <v-card class="add-card-dialog">
        <div class="add-card-header">
          <div><div class="add-card-title">Payment method</div><div class="add-card-subtitle">Add a secure card for future subscription payments.</div></div>
          <v-btn icon small @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text v-if="currentBusiness" class="pa-5">
          <v-card flat outlined class="card-input-wrap">
            <v-card-text>
              <card
                ref="card"
                class="stripe-card"
                :class="{ complete }"
                :stripe="stripePublicKey"
                @change="complete = $event.complete"
              />
            </v-card-text>
          </v-card>
          <v-card-text>
            <v-switch
              v-if="sources && sources.length > 0"
              v-model="defaultCard"
              inset
              label="Make is card default for future payments"
            ></v-switch>
          </v-card-text>
        </v-card-text>

        <v-img class="stripe-image" src="@/assets/images/stripeimg.jpg" />

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="isLoading"
            :disabled="!complete"
            color="primary"
            rounded
            depressed
            @click="submit"
          >
            Save Card
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Card, createToken } from "vue-stripe-elements-plus";
import accountService from "@/modules/Account/service.js";
import { mapGetters } from "vuex";

export default {
  props: {
    sources: { type: Array, default: () => [] },
    buttonLabel: { type: String, default: "Add Card" },
  },
  data() {
    return {
      defaultCard: false,
      isLoading: false,
      dialog: false,
      cards: [],
      complete: false,
      stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      stripe: null,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.sources && this.sources.length > 0) {
          this.defaultCard = false;
        } else {
          this.defaultCard = true;
        }
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  components: {
    Card,
  },
  methods: {
    close() {
      this.$refs.card.clear();
      this.dialog = false;
    },
    async submit() {
      try {
        this.isLoading = true;
        const data = await createToken();
        const card = await accountService.addCard({
          card: {
            customer_id: this.currentBusiness.customer_id,
            source: data.token.id,
          },
        });
        // console.log('card', card)
        if (this.defaultCard) {
          let updateCard = {
            customer_id: this.currentBusiness.customer_id,
            default_source: card.data.id,
          };
          await accountService.changeDefaultCard(updateCard);
        }
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Card was added!",
          });
        this.isLoading = false;
        this.$emit("submit");
        this.close();
      } catch (error) {
        // console.log("error adding card", error);
        this.isLoading = false;
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
      }
    },
  },
};
</script>

<style scoped>
.add-card-dialog{border-radius:20px!important;overflow:hidden}.add-card-header{padding:18px 20px;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;justify-content:space-between}.add-card-title{font-size:19px;font-weight:800;color:#0f172a}.add-card-subtitle{font-size:12px;color:#64748b;margin-top:2px}.card-input-wrap{border-radius:14px!important}.stripe-image{max-height:72px;object-fit:contain;margin:0 auto 12px;max-width:350px}
</style>
